module.exports = __webpack_public_path__ + "static/9-ad95384a51335415ee66bfaac6a239aa.jpg";